import { render, staticRenderFns } from "./New.vue?vue&type=template&id=0ac02110&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac02110')) {
      api.createRecord('0ac02110', component.options)
    } else {
      api.reload('0ac02110', component.options)
    }
    module.hot.accept("./New.vue?vue&type=template&id=0ac02110&", function () {
      api.rerender('0ac02110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/New.vue"
export default component.exports